export default __webpack_public_path__ + "static/sztolcman-10fb59f72e1bf041045ba3424c121050.jpg";